import React, {useEffect} from "react";
import {Wrapper} from "../index";
import styles from "./styles";
import {withStyles} from "@material-ui/core";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {hoverPoi, loadDistrictData} from "../../store/district";
import {Header} from "../../components";
import PoiOnMap from "./PoiOnMap";
import PoiRightMenu from "./PoiRightMenu";
import MobileMedia from "../../components/MobileMedia/MobileMedia";

const DistrictMode = ({classes}) => {
	const dispatch = useDispatch();
	const {data} = useSelector(state => state.district);
	useEffect(() => {
		dispatch(loadDistrictData());
		dispatch(hoverPoi(null))
	}, []);
	return (
		<Wrapper id="layout" className={classes.wrapper}>
			<Header/>
			<>
				{data && (
					<>
						<PoiOnMap classes={classes} className={classes.main} data={data}/>
						<PoiRightMenu
							classes={classes}
							data={data}
							className={classes.sidebar}
						/>
						<MobileMedia/>
					</>
				)}
			</>
		</Wrapper>
	);
};
DistrictMode.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DistrictMode);
